import { Action } from 'redux';

import { KonsiergeMessage } from '../models/KonsiergeMessage';
import {
    REQUEST_HISTORY,
    RECEIVE_HISTORY,
    ERROR_HISTORY,
    RESPONSE_CLIENT_TYPING,
    REQUEST_MESSAGE_SEND,
    RESPONSE_MESSAGE_SEND,
    ERROR_MESSAGE_SEND,
    MESSAGES_VIEWED_BY_OPERATOR,
    RECEIVE_MESSAGE,
    MESSAGE_UPDATE,
    REQUEST_FILE_SEND,
    RESPONSE_FILE_SEND,
    ERROR_FILE_SEND,
    RESPONSE_GET_COUNTERS,
    SEEN_MESSAGE
} from '../actions/chats';
import { OrderedMap } from 'immutable';

export interface ChatsState {
    discussionId?: number;
    messages: OrderedMap<any, KonsiergeMessage>;
    chatInfo: any;
    message: KonsiergeMessage;
    loadingSendMessage: boolean;
    errorSendMessage: any;
    countersUnreadMessages: OrderedMap<number, number>;
}

const initialState: ChatsState = {
    discussionId: undefined,
    messages: OrderedMap<any, KonsiergeMessage>(),
    chatInfo: {},
    message: {} as KonsiergeMessage,
    loadingSendMessage: false,
    errorSendMessage: null,
    countersUnreadMessages: OrderedMap<number, number>(),
};

export function chatsState(state: ChatsState = initialState, action: Action) {
    switch (action.type) {
        case REQUEST_HISTORY: {
            return {
                ...state,
                loadingHistory: true,
            };
        }
        case RECEIVE_HISTORY: {
            const messages: KonsiergeMessage[] = (action as any).response;
            const discussionId = (action as any).attached.discussionId;
            let oldMessages = state.messages;
            let chatInfo = state.chatInfo || {};
            if (state.discussionId && state.discussionId !== discussionId) {
                oldMessages = oldMessages.clear();
                chatInfo = {};
            }
            if (messages.length > 0) {
                chatInfo.firstMessage = messages[messages.length - 1];
                chatInfo.lastMessage = messages[0];
            } else {
                chatInfo.fullHistory = true;
            }
            let newMessagesMap = messages.reduce((acc, message) => acc.set(message._id, message), oldMessages ? oldMessages : OrderedMap<any, KonsiergeMessage>());
            if (newMessagesMap.size === 0 && messages.length === 0 && state.discussionId === discussionId) {
                newMessagesMap = state.messages;
            }
            return {
                ...state,
                loadingHistory: false,
                discussionId,
                messages: newMessagesMap,
                chatInfo: chatInfo,
            };
        }
        case ERROR_HISTORY: {
            return {
                ...state,
                loadingHistory: false,
            };
        }
        case SEEN_MESSAGE: {
            const discussionId = (action as any).discussionId;
            let countersUnreadMessages = state.countersUnreadMessages;
            countersUnreadMessages = countersUnreadMessages.set(discussionId, 0);
            return {
                ...state,
                countersUnreadMessages
            };
        }
        case RESPONSE_CLIENT_TYPING: {
            return {
                ...state,
            };
        }
        case REQUEST_MESSAGE_SEND: {
            return {
                ...state,
                loadingSendMessage: true,
                errorSendMessage: initialState.errorSendMessage,
                message: initialState.message,
            };
        }
        case RESPONSE_MESSAGE_SEND: {
            const response = (action as any).response;
            const message = (action as any).attached;
            if (response.content !== message.content) {
                return {
                    ...state,
                    loadingSendMessage: false,
                    errorSendMessage: {
                        error: {
                            code: 999,
                            message: 'invalid hash ' + message.content
                        },
                    },
                };
            }
            // TODO: выпилить, наверно
            let chatInfo = state.chatInfo || {};
            chatInfo.lastMessage = response;

            let oldMessages = state.messages;
            if (state.messages && state.messages.first() && oldMessages &&
                (response.discussion_type_id !== state.messages.first().discussion_type_id || response.discussion_id !== state.messages.first().discussion_id)) {
                oldMessages = oldMessages.clear();
            }
            let newMessageMap = OrderedMap<any, KonsiergeMessage>();
            newMessageMap = newMessageMap.set(response._id, response);

            return {
                ...state,
                loadingSendMessage: false,
                message: response,
                messages: oldMessages ? newMessageMap.concat(oldMessages) : newMessageMap,
                chatInfo: chatInfo
            };
        }
        case ERROR_MESSAGE_SEND: {
            const errorSendMessage = action as any;
            return {
                ...state,
                loadingSendMessage: false,
                errorSendMessage,
            };
        }
        case MESSAGES_VIEWED_BY_OPERATOR: {
            if (state.messages && state.messages.first() && (action as any).discussion_type_id === state.messages.first().discussion_type_id) {
                const updatedMessages = state.messages.map(message => {
                    if (message!.status_new !== 'seen' && message!.owner_type === 'client') {
                        let messageWithNewStatus = message;
                        messageWithNewStatus!.status_new = 'seen';
                        return messageWithNewStatus;
                    }
                    return message;
                });
                return {
                    ...state,
                    messages: updatedMessages
                };
            }
            return {
                ...state,
            };
        }
        case RECEIVE_MESSAGE: {
            const result = (action as any).message;
            const newMessages = result.map(message => JSON.parse(message));
            let countersUnreadMessages = state.countersUnreadMessages;
            newMessages.forEach(message => countersUnreadMessages = countersUnreadMessages.set(message.discussion_id, countersUnreadMessages.get(message.discussion_id) + 1));
            if (newMessages.length > 0 && state.messages && state.messages.first() && newMessages[0].discussion_type_id === state.messages.first().discussion_type_id && newMessages[0].discussion_id === state.messages.first().discussion_id) {
                let newMessagesMap = OrderedMap<any, KonsiergeMessage>();
                newMessages.forEach(message => newMessagesMap = newMessagesMap.set(message._id, message));
                return {
                    ...state,
                    messages: newMessagesMap.concat(state.messages),
                    countersUnreadMessages
                };
            }
            return {
                ...state,
                countersUnreadMessages
            };
        }
        case MESSAGE_UPDATE: {
            const updatedMessages = (action as any).message;
            if (updatedMessages.length > 0 && state.messages.first() && updatedMessages[0].discussion_type_id === state.messages.first().discussion_type_id && updatedMessages[0].discussion_id === state.messages.first().discussion_id) {
                let messages = state.messages;
                updatedMessages.forEach(message => messages = messages.set(message._id, message));
                return {
                    ...state,
                    messages
                };
            }
            return {
                ...state,
            };
        }
        case REQUEST_FILE_SEND: {
            return {
                ...state
            };
        }
        case ERROR_FILE_SEND: {
            const errorSendFile = action as any;
            return {
                ...state,
                errorSendMessage: errorSendFile
            };
        }
        case RESPONSE_FILE_SEND: {
            const status = (action as any).response.messages[0].status;
            if (status === 200) {
                alert('Произошла ошибка, повторите пожалуйста отправку файла!');
                return {
                    ...state,
                    loadingSendMessage: false,
                };
            }
            const response = (action as any).response.messages[0].message;
            // TODO: выпилить, наверно
            let chatInfo = state.chatInfo;
            chatInfo.lastMessage = response;

            let oldMessages = state.messages;
            if (state.messages[0] && response.discussion_id !== state.messages[0].discussion_id && oldMessages) {
                oldMessages = oldMessages.clear();
            }
            let newMessageMap = OrderedMap<any, KonsiergeMessage>();
            newMessageMap = newMessageMap.set(response._id, response);

            return {
                ...state,
                loadingSendMessage: false,
                message: response,
                messages: newMessageMap.concat(oldMessages),
                chatInfo: chatInfo
            };
        }
        case RESPONSE_GET_COUNTERS: {
            const result = (action as any).response.result;
            let countersUnreadMessages: OrderedMap<number, number> = OrderedMap<number, number>();
            result.map(res => {
                countersUnreadMessages = countersUnreadMessages.set(res.id, res.count_of_new_messages);
            });
            return {
                ...state,
                countersUnreadMessages
            };
        }
        /*case OPERATOR_TYPING: {
            if (state.messages.first() && action as any).discussion_type_id === state.messages.first().discussion_type_id) {
                console.log(action as any);
            }
            return {
                ...state,
            };
        }*/
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/chats.ts